module.exports = __webpack_public_path__ + "static/media/profile.05556a85.png";